export * from './virtual-product-list.module';
